import './choose.css';
import icon1 from './icon1.jpeg';
import icon2 from './icon2.jpeg';
import icon3 from './icon3.jpeg';

function Choose(){
    return (
        <section className='choose'>
            <h1>Escolha um Serviço</h1>

            <div className="row">
                <div className="cards">
                    <img src={icon1} alt="Icone de Click" />
                    <p>Escolha o serviço, entre em contato conosco de maneira conveniente, solicitada no formulário em nosso site. Você  será guiado durante o processo.</p>
                </div>
                <div className="cards">
                    <img src={icon2} alt="Icone de Prancheta" />
                    <p>Enviaremos um orçamento para você. Este orçamento é elaborado com base nas suas preferências e nas características únicas do serviço escolhido.</p>
                </div>
                <div className="cards">
                    <img src={icon3} alt="Icone de finalização" />
                    <p>Finalmente, chega o momento de entregar o produto. Estamos comprometidos em garantir sua satisfação em cada etapa do processo.</p>
                </div>
            </div>
        </section>
    )
}

export default Choose;